<template>
  <AIAssistantBaseChatResponse v-if="aiSummaryChatHistory?.result">
    <div class="tw:mb-5">
      {{
        getLocaleText("ai_summary_panel.summary_complete", {
          label: aiSummaryChatHistory.result.title,
        })
      }}
    </div>

    <AIAssistantBaseChatTransition
      appear
      class="tw:grid tw:gap-4"
      group
    >
      <AISummaryStreamCluster
        v-for="(summaryTopic, summaryTopicIndex) in aiSummaryChatHistory.result
          .topics"
        :key="summaryTopicIndex"
        assistant
        :data-index="summaryTopicIndex"
        :stream-id="aiSummaryChatHistory.result.streamId"
        :summary-topic-history="summaryTopic"
        :topic-id="summaryTopic.id"
      />
    </AIAssistantBaseChatTransition>
  </AIAssistantBaseChatResponse>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import { getLocaleText } from "shared/boot/i18n";
import AIAssistantBaseChatResponse from "shared/components/AI/AIAssistant/AIAssistantBaseChatResponse.vue";
import AIAssistantBaseChatTransition from "shared/components/AI/AIAssistant/AIAssistantBaseChatTransition.vue";
import { type AIChatHistory } from "shared/composables/useAIChatHistory";
import useAIStore from "shared/stores/ai";

import AISummaryStreamCluster from "./AISummaryStreamCluster.vue";

interface AISummaryChatHistoryProps {
  message?: AIChatHistory;
}

defineProps<AISummaryChatHistoryProps>();

const aiStore = useAIStore();
const { aiSummaryChatHistory } = storeToRefs(aiStore);
</script>
